

var PlaceObjectAR = function()
{

	this.readyToUse3d    = false;
	this.readyToUseGltf  = false;
	this.readyToUseX8    = false;
	this.readyToUseXtras = false;
	this.readyToLaunchAr = false;

};

PlaceObjectAR.prototype =
{

    init: function( data )
    {

    	var _self = this;
  		let checkForXR = null;


    	checkForXR = setInterval( function() { 

	        if( typeof window.THREE !== "undefined" ) {

	            if( !_self.readyToUseGltf ) {
	             
	            	var threeGltfLoader = document.createElement('script');
	            	threeGltfLoader.src = '//cdn.rawgit.com/mrdoob/three.js/r106/examples/js/loaders/GLTFLoader.js';
	            	document.head.appendChild( threeGltfLoader );

	            	var threeDracoLoader = document.createElement('script');
	            	threeDracoLoader.src = '//cdn.rawgit.com/mrdoob/three.js/r106/examples/js/loaders/DRACOLoader.js';
	            	document.head.appendChild( threeDracoLoader );

	            	var threeLightProbe = document.createElement('script');
	            	threeLightProbe.src = '//cdn.rawgit.com/mrdoob/three.js/r106/examples/js/lights/LightProbeGenerator.js';
	            	document.head.appendChild( threeLightProbe );

	            	_self.readyToUseGltf = true;

	            }


	            if( !_self.readyToUseX8 && !_self.readyToUseXtras ) {

			          var xrXtra = document.createElement('script');
			          //script.async = false;
			          xrXtra.src = '//cdn.8thwall.com/web/xrextras/xrextras.js';
			          document.head.appendChild(xrXtra);

			          var xrMain = document.createElement('script');
			          xrMain.async = true;
			          xrMain.src = '//apps.8thwall.com/xrweb?appKey=k8aPO0Xta3Yk8FfMwgtuqtbqotHq2D4oxIUZRR80h6xwLkJAl9o8H8HLtc8oo2Ey1jo5f8';
			          document.head.appendChild(xrMain);

			          _self.readyToUseX8    = true;
			          _self.readyToUseXtras = true;


	            }

	            _self.readyToUse3d = true;


	        }


    		if( typeof window.THREE !== "undefined" && typeof window.XRExtras !== "undefined" && typeof window.XR8 !== "undefined" ) {
    			
    			if( !_self.readyToLaunchAr ) {             
		        	
		        	var setArJs = document.createElement('script');
		        	setArJs.src = './js/ar.js';
		        	document.head.appendChild( setArJs );

		        	_self.readyToLaunchAr = true;
    			
    			} else {

    				document.getElementById( "loading" ).style.opacity = 0.5;

    				if( window["launchAr"] ) {

    					window["launchXR8"]( data );
    					clearInterval( checkForXR );

    				}

    			}
		
	        }

        }, 200);

    },

};

export default PlaceObjectAR;